import $ from 'jquery'

import 'blueimp-canvas-to-blob'
import 'blueimp-file-upload'

import csrf from './csrf'

var defaults = {
  elem: null,
  name: undefined,
  ctx: '',

  browse: undefined,
  start_record: undefined,
  stop_record: undefined,
  play_sound: undefined,
  stop_sound: undefined,
  delete_sound: undefined,
  input: undefined,

  failure: 'Error uploading',

  yp: undefined,
  uploadurl: null,
  name: null,
  initFinCallback: undefined,
}

var recorder = null
const recordAudio = (x) => new Promise(resolve => {
    navigator.mediaDevices.getUserMedia({ audio: x })
      .then(stream => {
        const mediaRecorder = new MediaRecorder(stream)
        const audioChunks = []

        mediaRecorder.addEventListener('dataavailable', event => {
          audioChunks.push(event.data)
        })

        const start = () => {
          mediaRecorder.start()
        }

        const stop = () => new Promise(resolve => {
            mediaRecorder.addEventListener('stop', () => {
              resolve(new Blob(audioChunks))
            })

            mediaRecorder.stop()
          })

        const settings = () => {
          var s = {}
          s.mime = mediaRecorder.mimeType
          console.log('SET', s)
          console.log('STREAM', stream)
          let audioTracks = stream.getAudioTracks()
          console.log('TRACK', audioTracks)
          if (audioTracks.length) {
            return { ...s, ...audioTracks[0].getSettings() }
          } else {
            return {}
          }
        }

        resolve({ start, stop, settings })
      })
  })

var audio = null

var setAudio = function (D, blob) {
  console.log('SoundRecord::setAudio')
  var inner = null
  if (blob instanceof HTMLAudioElement) {
    inner = blob
  } else if (blob instanceof File) {
    inner = new Audio(URL.createObjectURL(blob))
  } else if (blob instanceof Blob) {
    inner = new Audio(URL.createObjectURL(blob))
  } else {
    console.log('SoundRecord::setAudio, unknown', blob, typeof blob, blob.constructor.name)
    return
  }

  audio = {
    play: (x) => {
      inner.play()
      if (typeof x == 'function') {
        inner.addEventListener('ended', (event) => { x() })
      }
    },
    pause: () => {
      inner.pause()
    },
  }
}

var show = function (D, state) {
  if (state == 'empty') {
    D.browse.show()
    D.start_record.show()
    D.stop_record.hide()
    D.play_sound.hide()
    D.pause_sound.hide()
    D.delete_sound.hide()
  }
  if (state == 'recording') {
    D.browse.hide()
    D.start_record.hide()
    D.stop_record.show()
    D.play_sound.hide()
    D.pause_sound.hide()
    D.delete_sound.hide()
  }
  if (state == 'stopped') {
    D.browse.hide()
    D.start_record.hide()
    D.stop_record.hide()
    D.play_sound.show()
    D.pause_sound.hide()
    D.delete_sound.show()
  }
  if (state == 'playing') {
    D.browse.hide()
    D.start_record.hide()
    D.stop_record.hide()
    D.play_sound.hide()
    D.pause_sound.show()
    D.delete_sound.show()
  }
}

var initUpload = function (D) {
  console.log('SoundRecord::initUpload')
  D.input.fileupload({
    type: 'POST',
    dataType: 'json',
    headers: csrf(),
    url: D.uploadurl,
    paramName: 'file',
    singleFileUploads: false,
    maxFileSize: 52428801,
    maxNumberOfFiles: 1,
    autoUpload: true,
    disableImageResize: true,
  }).on('fileuploaddone', function (e, data) {
    console.log('SoundRecord::fileuploaddone', e, data, data.result)
    D.name.val(data.result.file)
    show(D, 'stopped')
    setAudio(D, data.files[0])
    initUpload(D)
  }).on('fileuploadfail', function (e, data) {
    console.log('Upload::fileuploadfail', e, data)
    D.name.val('')
    D.yp.addError(D.failure)
    show(D, 'empty')
    initUpload(D)
  }).on('fileuploadprogress', function (e, data) {
    var value = parseInt(data.loaded / data.total * 100, 10) || 0
    console.log('SoundRecord::progress received: ' + value + '%')
  }).on('fileuploadprogressall', function (e, data) {
    var value = parseInt(data.loaded / data.total * 100, 10) || 0
    console.log('SoundRecord::progress received: ' + value + '%')
  }).on('fileuploadstart', function (e) {
    console.log('SoundRecord::fileuploadstart')
  })
}

export default {
  init: function (opts) {
    var D = $.extend({}, defaults, opts || {})
    console.log('SoundRecord::init', D)

    if (D.elem === null || D.elem === '') {
      console.error('SoundRecord::elem cannot be null', D)
      return
    }
    if (typeof D.elem === 'string') {
      D.elem = $(D.elem)
    }
    if (D.elem.length === 0) {
      console.error('SoundRecord::elem does not exist', D)
      return
    }

    D.browse = D.elem.find('.btn.browse')
    if (D.browse.length === 0) {
      console.error('SoundRecord::could not find a browse', D)
      return
    }

    D.start_record = D.elem.find('.btn.start-record')
    if (D.start_record.length === 0) {
      console.error('SoundRecord::could not find a start-record', D)
      return
    }

    D.stop_record = D.elem.find('.btn.stop-record')
    if (D.stop_record.length === 0) {
      console.error('SoundRecord::could not find a stop-record', D)
      return
    }

    D.play_sound = D.elem.find('.btn.play-sound')
    if (D.play_sound.length === 0) {
      console.error('SoundRecord::could not find a play-sound', D)
      return
    }

    D.pause_sound = D.elem.find('.btn.pause-sound')
    if (D.pause_sound.length === 0) {
      console.error('SoundRecord::could not find a pause-sound', D)
      return
    }

    D.delete_sound = D.elem.find('.btn.delete-sound')
    if (D.delete_sound.length === 0) {
      console.error('SoundRecord::could not find a delete-sound', D)
      return
    }

    D.input = D.elem.find('input.upload-sound')
    if (D.input.length === 0) {
      console.error('SoundRecord::could not find the file input.upload-sound element', D)
      return
    }

    if (D.elem.data('upload-url')) {
      D.uploadurl = D.elem.data('upload-url')
    }
    if (D.uploadurl === null || D.uploadurl === '') {
      console.error('SoundRecord::uploadurl cannot be null', D)
      return
    }
    if (D.uploadurl.indexOf('/') === 0) {
      D.uploadurl = D.ctx + D.uploadurl
      console.log('using ctx [' + D.ctx + '] for the upload url')
      console.log('uploadurl: [' + D.uploadurl + ']')
    }

    if (D.elem.data('failure')) {
      D.failure = D.elem.data('failure')
    }

    if (D.elem.data('file-name')) {
      D.name = D.elem.data('file-name')
    }
    if (D.name === null || D.name === '') {
      console.error('SoundRecord::name cannot be null', D)
      return
    }
    if (typeof D.name === 'string') {
      D.name = $('[name="' + D.name + '"]')
    }
    if (D.name.length === 0) {
      console.error('SoundRecord::name does not exist', D)
      return
    }

    initUpload(D)

    D.browse.click(function (e) {
      console.log('SoundRecord::browse');
      e.preventDefault();
      D.input.trigger('click')
    })

    D.start_record.click(function () {
      (async () => {
        console.log('SoundRecord::start');
        audio = null
        recorder = await recordAudio({
            channelCount: 1,
            autoGainControl: false,
            echoCancellation: false,
            noiseSuppression: false,
            sampleRate: 48000,
            sampleSize: 32,
            volume: 1.0,
          })
        recorder.start()
        show(D, 'recording')
      })()
    })

    D.stop_record.click(function () {
      (async () => {
        console.log('SoundRecord::stop')
        const blob = await recorder.stop()
        recorder = null
        D.input.fileupload('add', { files: [blob] })
      })()
    })

    D.play_sound.click(function () {
      if (audio) {
        console.log('SoundRecord::play')
        audio.play(() => { show(D, 'stopped') })
        show(D, 'playing')
      }
    })

    D.pause_sound.click(function () {
      if (audio) {
        console.log('SoundRecord::pause')
        audio.pause()
        show(D, 'stopped')
      }
    })

    D.delete_sound.click(function () {
      if (audio) {
        console.log('SoundRecord::delete')
        D.name.val('')
        audio.pause()
        audio = null
        show(D, 'empty')
      }
    })

    var serverAudio = D.elem.find('audio')
    if (serverAudio.length !== 0) {
      setAudio(D, serverAudio[0])
      show(D, 'stopped')
    } else {
      show(D, 'empty')
    }

    if (typeof D.initFinCallback == 'function') {
      D.initFinCallback(D)
    }
  },
}
